import { Component, OnInit } from '@angular/core';
import { SkillService } from '../services/skill.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { CategoryResponse, DepartmentResult, CategoryResult } from '../api-interfaces';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-create-skill',
  templateUrl: './create-skill.component.html',
  styleUrls: ['./create-skill.component.css']
})
export class CreateSkillComponent implements OnInit {

  lists: Observable<CategoryResponse[]>
  departmentList: DepartmentResult[]
  categoryList: CategoryResult[]
  skillForm: FormGroup;
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    public skillService: SkillService,
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.lists = this.skillService.getCategory();
    this.skillForm = this.formBuilder.group({
      skill_name: new FormControl('', Validators.required),
      category_id: new FormControl('', Validators.required),
      department_id: new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    this.getCategoryByDepartment();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  locationBack() {
    this.location.back();
  }

  validateFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      } else if (control instanceof FormGroup) {
        this.validateFormGroup(control);
      }
    });
  }

  newSkill(formData) {
    this.validateFormGroup(formData);
    if (formData.valid) {
      this.spinnerService.show();
      this.skillService.newskill(formData.value).takeUntil(this.destroy)
        .subscribe(data => {
          if (data['status'] == true) {
            this.spinnerService.hide();
            this.flashService.show(data['message'], 'alert-success');
            this.router.navigateByUrl('skillList');
          }
        },
          error => {
            this.spinnerService.hide();
            this.flashService.show(error['error']['message'], 'alert-danger');
          });
    }
  }

  getCategoryByDepartment() {
    this.skillService.getCategoryDepartment().takeUntil(this.destroy)
      .subscribe(data => {
          this.departmentList = data;
      })
  }

  getCategoryByDepartmentId(departmentid_element) {
    let categories = this.departmentList;
    for ( let row in categories ) {
      if ( categories[row].department_id == departmentid_element ) {
        this.categoryList = categories[row].category;
        break;
      }
    }
  }

  trackByFn(index) {
    return index;
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/create-skill/create-skill.component.ts